import { SearchType } from '@src/quince-site-common/src/services/orderAggregatorService/orderAggregatorService.types'
import { getDeviceIdFromLocalStorage } from '@src/quince-site-common/src/utils/getlb-user-id'

export const getFmoTrackingId = (customerMetadata?: { customerId?: string }) => {
  const customerId = customerMetadata?.customerId
  if (customerId) return { customerId }
  return { deviceId: getDeviceIdFromLocalStorage() ?? '' }
}

export const FORM_CONFIG = {
  optionsList: [SearchType.ORDER_NUMBER_ZIP, SearchType.EMAIL, SearchType.CARD_LAST_FOUR_ZIP],
  [SearchType.ORDER_NUMBER_ZIP]: {
    searchDisplayText: 'order_number',
    fields: [
      {
        labelKey: 'order_number',
        type: 'text',
        id: 'orderNumber',
      },
      {
        labelKey: 'enter_shipping_code',
        type: 'text',
        id: 'zipCode',
      },
    ],
  },
  [SearchType.EMAIL]: {
    searchDisplayText: 'email_address_v1',
    fields: [
      {
        labelKey: 'enter_email_address',
        type: 'email',
        id: 'email',
      },
    ],
  },
  [SearchType.CARD_LAST_FOUR_ZIP]: {
    searchDisplayText: 'payment_information',
    fields: [
      {
        labelKey: 'enter_your_card_number',
        type: 'text',
        id: 'cardNumber',
      },
      {
        labelKey: 'enter_shipping_code',
        type: 'text',
        id: 'zipCode',
      },
    ],
  },
}

export const RESEND_TIMER = 30
export const TOAST_DURATION = 3000

export interface FormField {
  labelKey: string
  type: string
  id: string
}

export const ERROR_CODES = {
  OTP_EXPIRED_MESSAGE: 'OTP_EXPIRED_MESSAGE',
  INVALID_OTP: 'INVALID_OTP',
  CUSTOMER_NOT_FOUND: 'CUSTOMER_NOT_FOUND',
}

export const MESSAGE_CONFIG = {
  success: {
    title: 'no_matches_found',
    subtitle: 'select_a_different_method',
    description: {
      label1: 'need_help',
      //eslint-disable-next-line i18next/no-literal-string
      label2: 'contact_us_v1',
      label3: '',
    },
  },
  error: {
    title: 'trouble_finding_your_order',
    subtitle: 'search_error_message',
    description: {
      label1: '',
      //eslint-disable-next-line i18next/no-literal-string
      label2: 'contact_us_v4',
      label3: 'happy_to_help',
    },
  },
}

export const STATSIG_FLAG_FIND_MY_ORDER_GUEST = 'enableFMOForGuestUser'
